// React
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

// Servisni sloj
import { exchangeImpersonationCode } from "services/auth/api";
import { setImpersonatedBy } from "services/auth/impersonation";
import { setAccessToken } from "services/auth/services";

// UI
import { Button } from "ui/components/Button/Button";

// Moduli specifični za projekt
import { Routes as PublicRoutes } from "ui/modules/public/navigation";

// Tipovi
import { ImpersonatePageCmp, ImpersonatePageProps } from "./types";

/**
 * Ulaz kad naše osoblje otvori aplikaciju kao klijentov korisnik.
 *
 * Iz adrese dolazi jednokratni kod koji se mijenja za tokene. Nakon toga se ide na početnu
 * punim učitavanjem, a ne kroz router: aplikacija tako pokupi novu sesiju na svom uobičajenom
 * putu, umjesto da je se naknadno ubacuje u stanje koje je već postavljeno.
 */
const ImpersonatePage: ImpersonatePageCmp = (_props: ImpersonatePageProps) => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  // Kod se troši pri prvoj razmjeni, pa drugi poziv iz istog otvaranja ne smije proći.
  const isExchangingRef = useRef<boolean>(false);

  useEffect(() => {
    const code = searchParams.get("code");

    if (!code) {
      setError("Veza ne sadrži kod za prijavu.");
      return;
    }

    if (isExchangingRef.current) return;

    isExchangingRef.current = true;

    const exchange = async () => {
      try {
        const result = await exchangeImpersonationCode(code);

        setAccessToken(result.accessToken, result.refreshToken, false);
        setImpersonatedBy(result.impersonatedBy);

        window.location.href = PublicRoutes.HomePage;
      } catch {
        setError("Kod je istekao ili je već iskorišten. Zatražite novu vezu iz admina.");
      }
    };

    exchange();
  }, [searchParams]);

  return (
    <div className="flex items-center justify-center min-h-screen px-4">
      <div className="w-full max-w-md text-center">
        {error ? (
          <>
            <h1 className="text-xl font-bold text-slate-900 mb-2">Prijava nije uspjela</h1>

            <p className="text-sm text-slate-600 mb-6">{error}</p>

            <Button
              variant="primary"
              children="Na prijavu"
              onClick={() => {
                window.location.href = PublicRoutes.LoginPage;
              }}
            />
          </>
        ) : (
          <p className="text-sm text-slate-600">Prijava u tijeku…</p>
        )}
      </div>
    </div>
  );
};

ImpersonatePage.route = PublicRoutes.ImpersonatePage;

export default ImpersonatePage;
